export const RECORD_TYPES = [
    { value: 'PREVENTIVE', label: 'Preventive Maintenance' },
    { value: 'BREAKDOWN', label: 'Breakdown / Repair' },
];

export const SERVICE_TYPES = [
    { value: 'OIL_SERVICE', label: 'Oil Service' },
    { value: 'FILTER_SERVICE', label: 'Filter Service' },
    { value: 'GREASE_SERVICE', label: 'Grease Service' },
    { value: 'GENERAL_SERVICE', label: 'General Service' },
    { value: 'TYRE_SERVICE', label: 'Tyre Service' },
    { value: 'HYDRAULIC_SERVICE', label: 'Hydraulic Service' },
    { value: 'ELECTRICAL_REPAIR', label: 'Electrical Repair' },
    { value: 'MECHANICAL_REPAIR', label: 'Mechanical Repair' },
    { value: 'OTHER', label: 'Other' },
];

export const SERVICED_BY_OPTIONS = [
    { value: 'IN_HOUSE', label: 'In House' },
    { value: 'VENDOR', label: 'External Vendor / Company' },
];

export function emptySparePartLine(lineNo = 1) {
    return {
        line_no: lineNo,
        part_name: '',
        part_number: '',
        quantity: 0,
        unit_cost: 0,
        total_cost: 0,
        user_remarks: '',
    };
}

export function defaultServiceInputs() {
    return {
        plant_id: '',
        equipment_id: '',
        record_type: 'PREVENTIVE',
        service_type: 'OIL_SERVICE',
        service_title: '',
        service_date: '',
        service_hm: 0,
        service_km: 0,
        next_service_due_date: '',
        next_service_due_hm: 0,
        next_service_due_km: 0,
        breakdown_cause: '',
        breakdown_details: '',
        serviced_by: 'IN_HOUSE',
        vendor_id: '',
        vendor_name: '',
        service_cost: 0,
        labour_cost: 0,
        parts_cost: 0,
        prepared_by: '',
        user_remarks: '',
        bill_file_url: '',
        service_report_file_url: '',
    };
}

export function buildServiceFormData(inputs, spareParts, files = {}, options = {}) {
    const formData = new FormData();
    const appendIfPresent = (key, value) => {
        if (value !== undefined && value !== null && value !== '') {
            formData.append(key, value);
        }
    };

    appendIfPresent('plant_id', inputs.plant_id);
    appendIfPresent('equipment_id', inputs.equipment_id);
    appendIfPresent('record_type', inputs.record_type);
    appendIfPresent('service_type', inputs.service_type);
    appendIfPresent('service_title', inputs.service_title);
    appendIfPresent('service_date', inputs.service_date);
    appendIfPresent('service_hm', inputs.service_hm);
    appendIfPresent('service_km', inputs.service_km);
    appendIfPresent('next_service_due_date', inputs.next_service_due_date);
    appendIfPresent('next_service_due_hm', inputs.next_service_due_hm);
    appendIfPresent('next_service_due_km', inputs.next_service_due_km);
    appendIfPresent('breakdown_cause', inputs.breakdown_cause);
    appendIfPresent('breakdown_details', inputs.breakdown_details);
    appendIfPresent('serviced_by', inputs.serviced_by);
    appendIfPresent('vendor_id', inputs.vendor_id);
    appendIfPresent('vendor_name', inputs.vendor_name);
    appendIfPresent('service_cost', inputs.service_cost);
    appendIfPresent('labour_cost', inputs.labour_cost);
    appendIfPresent('parts_cost', inputs.parts_cost);
    appendIfPresent('prepared_by', inputs.prepared_by);
    appendIfPresent('user_remarks', inputs.user_remarks);
    formData.append('spare_parts_list', JSON.stringify(spareParts || []));

    if (files.bill_file) formData.append('bill_file', files.bill_file);
    if (files.service_report_file) formData.append('service_report_file', files.service_report_file);
    if (options.clear_bill_file) formData.append('clear_bill_file', 'true');
    if (options.clear_service_report_file) formData.append('clear_service_report_file', 'true');

    return formData;
}

export function mapServiceRecordToForm(data) {
    return {
        plant_id: data.plant_id || '',
        equipment_id: data.equipment_id || '',
        record_type: data.record_type || 'PREVENTIVE',
        service_type: data.service_type || 'GENERAL_SERVICE',
        service_title: data.service_title || '',
        service_date: data.service_date || '',
        service_hm: data.service_hm || 0,
        service_km: data.service_km || 0,
        next_service_due_date: data.next_service_due_date || '',
        next_service_due_hm: data.next_service_due_hm || 0,
        next_service_due_km: data.next_service_due_km || 0,
        breakdown_cause: data.breakdown_cause || '',
        breakdown_details: data.breakdown_details || '',
        serviced_by: data.serviced_by || 'IN_HOUSE',
        vendor_id: data.vendor_id || '',
        vendor_name: data.vendor_name || '',
        service_cost: data.service_cost || 0,
        labour_cost: data.labour_cost || 0,
        parts_cost: data.parts_cost || 0,
        prepared_by: data.prepared_by || '',
        user_remarks: data.user_remarks || '',
        bill_file_url: data.bill_file_url || '',
        service_report_file_url: data.service_report_file_url || '',
    };
}
